import React, {Component} from 'react';
import {Container} from './styles';
import {IoMdClose} from 'react-icons/io';
import {Redirect} from 'react-router-dom';

import perfil from '../../../assets/perfil/perfil@3x.png';

export default class OptionsMobile  extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: 0,
            image: perfil,
        }
    }

    componentDidMount() {
        this.getImage();
    }

    async getImage() {
        const {logotipo} = this.props;
        if (logotipo !== undefined) {
            const image = `https://appedidos-share-private.s3.amazonaws.com/${logotipo}`
            this.setState({ image });
        }
    }

    async push() {
        await this.setState({
            redirect: 1
        });
        this.props.closeModal();
    }

    async logout() {
        try {
            await localStorage.removeItem('@username');
            await localStorage.removeItem('@jwt');
            await localStorage.removeItem('@user');
            await localStorage.removeItem('@rest');
            await localStorage.removeItem('@internal');
            await localStorage.removeItem('@uf');
            await localStorage.removeItem('@suser');
            this.setState({
                redirect: 2
            });
        } catch (e) {
            console.log(e.data);
        }
    }

    render() {
        if (this.state.redirect === 1) {
            return <Redirect push to="/novaSenha" />
        }
        if(this.state.redirect === 2) {
            return <Redirect to='/login' />
        }
        return(
            <Container>
                <div className="close">
                    <button 
                        onClick={() => this.props.closeModal()}>
                        <IoMdClose color="#fff" className="i-close" />
                    </button>
                </div>
                    <div className="restaurante">
                        <img 
                        alt=""
                        src={this.state.image}
                        className="perfil"
                         />

                        <div className="texto">
                            <h1 className="ola">
                                Olá,
                            </h1>

                            <div className="rest">
                                <h1 className="nome">
                                    {this.props.nome}
                                </h1>
                            </div>
                        </div>   
                    </div>

                    <hr/>

                    <div className="div-restaurante">

                        {/* <h1>Restaurante</h1>

                        <button 
                            onClick={() => this.props.change()}
                            className={this.props.status ? 'status-aberto' : 'status-fechado'}
                        >
                            <h1 className="statusText">
                                Restaurante {this.props.status ? 'aberto' : 'fechado'}
                            </h1>
                        </button> */}

                            {/* <h2>
                                Clicando nesse botão você vai <span>{this.props.status ? 'fechar' : 'abrir'}</span> o seu restaurante.
                            </h2> */}

                    </div>

                    {/* <hr/> */}

                <div className="div-sair">
                    <h1>Minha Conta</h1>

                    <div className="buttons">
                        <button 
                            onClick={() => this.push()}
                            className="senha">Trocar senha</button>
                        <button 
                            onClick={async() => await this.logout()}
                            className="sair">Sair da conta</button>
                    </div>
                </div>

            </Container>
        )
    }
}